// © Microsoft Corporation. All rights reserved.
import { html, ref, slotted } from "@microsoft/fast-element";
import { FluentButton } from "@fluentui/web-components";
import { closeButtonGlyph, hamburgerMenuGlyph, microsoftLogo } from "../svg";
// Prevent tree shaking
FluentButton;
export const HamburgerMenuTemplate = html `
    <template role="tree">
        <fluent-button
            appearance="stealth"
            class="${x => (!x.showMenu ? "menu-button" : "hidden")}"
            @click="${x => x.openMenu()}"
            aria-label="${x => x.menuButtonTooltip}"
            title="${x => x.menuButtonTooltip}"
        >
            ${hamburgerMenuGlyph}
        </fluent-button>
        <div
            class="${x => (x.showMenu ? "overlay" : "hidden")} ${x => x.useMobileStyles ? "mobile" : ""}"
            ${ref("menuOverlay")}
        >
            <div class="menu">
                <div class="${x => (x.useMobileStyles ? "hidden" : "menu-header")}">
                    <slot name="logo">
                        ${microsoftLogo}
                    </slot>
                    <fluent-button
                        appearance="stealth"
                        class="close-button"
                        @click="${x => x.closeMenu()}"
                        aria-label="${x => x.closeButtonTooltip}"
                        title="${x => x.closeButtonTooltip}"
                    >
                        ${closeButtonGlyph}
                    </fluent-button>
                </div>
                <div class="menu-content">
                    <div
                        role="tree"
                        class="tree-view"
                        tabindex="${x => (x.focusable ? 0 : -1)}"
                        ${ref("treeView")}
                        @keydown="${(x, c) => x.handleKeyDown(c.event)}"
                        @focus="${(x, c) => x.handleFocus(c.event)}"
                        @blur="${(x, c) => x.handleBlur(c.event)}"
                    >
                        <slot ${slotted("slottedTreeItems")}></slot>
                    </div>
                </div>
            </div>
        </div>
    </template>
`;
